import React from 'react'
import { AuthContext } from '../context/auth/Auth'
import { useQueryClient } from '@tanstack/react-query'
import { Box, ButtonGroup, Flex, HStack, IconButton, Link, Text, Tooltip, useBreakpointValue } from '@chakra-ui/react'

import { FiLogOut } from '@react-icons/all-files/fi/FiLogOut'
import { FaUserCircle } from '@react-icons/all-files/fa/FaUserCircle'

import { Link as GatsbyLink } from 'gatsby'
import { TOP_LINKS } from '../utils/topLinks'

export function Header({ location }: any) {
  const isDesktop = useBreakpointValue({ base: false, md: true, lg: true })

  const queryClient = useQueryClient()
  const auth = React.useContext<any>(AuthContext)

  function logout() {
    queryClient.clear()

    //Remove inactivity variables
    localStorage.removeItem('expireTime')
    localStorage.removeItem('halfwayTime')
    localStorage.removeItem('expireTimeReadable')
    localStorage.removeItem('modalOpen')

    auth.actions.logout()
  }

  return (
    <Box as="section" position="sticky" top="0" bg="white" zIndex="1000" h="88px" borderBottom="1px solid" borderColor="blackAlpha.100">
      <Flex as="nav" h="100%" align="center" justify="space-between" px={{ base: 4, md: 8 }} gap={4}>
        <GatsbyLink to="/">
          <img src="/v2/images/EducationLogo.png" alt="IATSE Education & Training Portal" style={{ height: isDesktop ? '56px' : '40px' }} />
        </GatsbyLink>

        <HStack spacing={{ base: 3, md: 8 }} fontSize="sm">
          {isDesktop && (
            <HStack spacing={{ base: 4, md: 8 }} color="blackAlpha.800">
              <Link href={TOP_LINKS.emailUs}>Email Us</Link>
              <Link href={TOP_LINKS.iatseWebsite} isExternal>
                Visit IATSE Website
              </Link>
              <Link href={TOP_LINKS.trainingTrustFund} isExternal>
                Training Trust Fund
              </Link>
            </HStack>
          )}

          {isDesktop && auth?.user?.userName && (
            <Text fontWeight={600} color="blackAlpha.800" whiteSpace="nowrap">
              Welcome, {auth.user.userName}
            </Text>
          )}

          <ButtonGroup colorScheme="blackAlpha" variant="ghost" spacing="1">
            <Tooltip label={`Logged in as ${auth?.user?.userName}`} openDelay={800}>
              <IconButton icon={<FaUserCircle fontSize="1.25rem" />} aria-label="user" />
            </Tooltip>
            <Tooltip label={'Logout'} openDelay={800}>
              <IconButton
                icon={<FiLogOut fontSize="1.25rem" />}
                aria-label="Logout"
                onClick={logout}
                id="header_actions-logout"
              />
            </Tooltip>
          </ButtonGroup>
        </HStack>
      </Flex>
    </Box>
  )
}
